import { EmailTemplateApi } from '@api';
import { emailTemplateTypes as actionTypes } from './types';

export const fetchEmailTemplates = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST.LOADING,
  });

  const stateKey = [params.offerId, params.affiliateId].join('-');

  EmailTemplateApi.getList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.SUCCESS,
        payload: {
          ...response,
          stateKey,
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
